import {Component, inject} from '@angular/core';
import {DialogFooterContext} from './dialog-footer.context';
import {ShortcutService} from '../../shortcuts/shortcut.service';

@Component({
	selector: 'app-dialog-footer',
	template: `
		<div class="flex justify-content-between align-items-center h-2rem">
			@if (ctx.visible()) {
				<div class="">
					@if (ctx.error()) {
						{{ ctx.error() }}
					}
				</div>

				<div class="flex gap-3 text-500">
					@for (s of ctx.shortcuts(); track s) {
						<small class="text-xs gap-1 flex align-items-center">
							@for ( k of s.display; track k; let i = $index) {
								<kbd>
									@switch (k.kind) {
										@case ('key') {
											{{ k.value.trim() }}
										}
										@case ('modifier') {
											{{ modifier().trim() }}
										}
										@case ('arrow') {
											<i class="pi pi-arrow-{{ k.dir }}"></i>
										}
										@case ('icon') {
											<i class="pi {{ k.name }}"></i>
										}
									}
								</kbd>
								@if (i < s.keys.length - 1) {+}
							}
							{{ s.description }}
						</small>
					}
				</div>
			}
		</div>
	`
})
export class DialogFooterComponent {
	readonly ctx = inject(DialogFooterContext)
	readonly shortcutService = inject(ShortcutService)

	modifier = this.shortcutService.modifierKey
}
